import React from "react";
import ProgressHolder from "./section1/ProgressHolder";

const statistic = ({getBacktest, typeName, getRiskStatistics}) => {
  return (
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <h4 className="text-uppercase bold">statistics</h4>
        {getBacktest && getRiskStatistics.length ? (
          <ProgressHolder getBacktest={getBacktest} typeName={typeName} getRiskStatistics={getRiskStatistics}/>
        ) : null}
      </div>
    </div>
  );
};

export default statistic;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/statistic/statistics.jsx